// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 164 ? "chart" : chunkId) + ".bundle.d139f661534fd22090f3e98e3586169149e548b1.js";
};